import React, { Fragment, useEffect, useState } from "react";
import WebsiteWidget from "./WebsiteWidget";
import { connect } from "react-redux";

import { useParams } from "react-router-dom";
import { WebCallContextProvider } from "../Agents/context";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";

const WidgetProvider = (props) => {
    const { token } = useParams();
    return (
        <Fragment>
            <WebCallContextProvider>
            <WebsiteWidget token={token} />
            </WebCallContextProvider>
        </Fragment>
    )
}


const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WidgetProvider);